import './App.css';
import { Routes, Route } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { Navigate } from "react-router-dom";
import "./assets/fonts/font.css";
import Register from './pages/Register';
import Login from './pages/Login';
import Forgotpassword from './pages/forgot-password/forgot-password';
import Resetpassword from './pages/reset-password/Resetpassword';
import Confirmpassword from './pages/confirm-password/Confirmpassword';
import Home from './pages/home/Home';
import Experience from './pages/experience/Experience';
import Offers from './pages/offers/Offers';
import MerchantAgreement from './pages/merchant-agreement/MerchantAgreement';
import SubmissionGuidelines from './pages/submission-guidelines/SubmissionGuidelines';
import SpotLights from './pages/spotlight-videos/SpotLight';
import CategoryList from './pages/categorylist/CategoryList';
import Banners from './pages/banners/Banners';
import UnlimitedOffers from './pages/unlimitedoffers/UnlimitedOffers';
import About from './pages/about/About';
import VendorDetails from './pages/vendor-details/VendorDetails';
import BusinessBrands from './pages/business&brands/BusinessBrands';
import HomeCarouselOffer from './pages/home-carousel-offer/HomeCarouselOffer';
import VideoPost from './pages/videopost/VideoPost';
import SearchPage from './pages/search/SearchPage';
import Events from './pages/events/Events';
import EventDetails from './pages/eventdetails/EventDetails';
import EventCategoryList from './pages/eventcategorylist/EventCategoryList';
import Otp from './pages/auth/OtpPage';
import UserProfile from './pages/userprofile/UserProfile';
import NearYou from './pages/nearyou/NearYou';
import ExperienceList from './pages/experiencelist/ExperienceList';
import PrivacyPolicy from './pages/submission-guidelines/PrivacyPolicy';
import TermsOfUseForUsers from './pages/submission-guidelines/TermsOfUseForUsers';
import RuleOfUse from './pages/submission-guidelines/RuleOfUse';
import DownloadPage from './pages/downloadpage/DownloadPage';
function App() {
  return (
    <div className="App">
      {/* <Routes>
        THE 1ST ROUTE DIRECTLY REDIRECT TO HOME PAGE... NO REGISTER AND LOGIN PAGE SHOWS INITIALLY
        <Route path="/" element={<Navigate to="/" replace />} /> 
        <Route path="/" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route path="/reset-password" element={<Resetpassword />} />
        <Route path="/confirm-password" element={<Confirmpassword />} />
        <Route path="/" element={<Home />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/offers/:couponId/:categoryId" element={<Offers />} />
        <Route path="/merchantagreement" element={<MerchantAgreement />} />
        <Route path="/submissionguidelines" element={<SubmissionGuidelines />} />
        <Route path="/spotlights/:vendor_id?" element={<SpotLights />} />
        <Route path="/categorylist/:parentId" element={<CategoryList />} />
        <Route path="/banners/:bannerId" element={<Banners />} />
        <Route path="/unlimitedoffers" element={<UnlimitedOffers />} />
        <Route path="/about" element={<About />} />
        <Route path='/vendordetails/:user_id?' element={<VendorDetails />} />
        <Route path="/business&brands" element={<BusinessBrands />} />
        <Route path="/HomeCarouselOffer" element={<HomeCarouselOffer />} />
        <Route path="/videoposts" element={<VideoPost />} />
      </Routes> */}

      <Routes>
        {/* ROOT = HOME */}
        <Route path="/" element={<Home />} />

        {/* AUTH */}
        <Route path="/register" element={<Register />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route path="/reset-password" element={<Resetpassword />} />
        <Route path="/confirm-password" element={<Confirmpassword />} />

        {/* PAGES */}
        <Route path="/experience" element={<Experience />} />
        <Route path="/offers/:couponId/:categoryId" element={<Offers />} />
        <Route path="/merchantagreement" element={<MerchantAgreement />} />
        <Route path="/submissionguidelines" element={<SubmissionGuidelines />} />
        <Route path="/spotlights/:user_id?" element={<SpotLights />} />
        <Route path="/categorylist/:parentId" element={<CategoryList />} />
        <Route path="/banners/:bannerId" element={<Banners />} />
        <Route path="/unlimitedoffers" element={<UnlimitedOffers />} />
        <Route path="/about" element={<About />} />
        <Route path="/vendordetails/:user_id?" element={<VendorDetails />} />
        <Route path="/business-and-brands" element={<BusinessBrands />} />
        <Route path="/HomeCarouselOffer" element={<HomeCarouselOffer />} />
        <Route path="/videoposts" element={<VideoPost />} />
        <Route path="/searchpage/:vendorId?" element={<SearchPage />} />
        <Route path="/events" element={<Events />} />
        <Route path="/eventdetails/:eventId" element={<EventDetails />} />
        <Route path="/eventcategorylist/:eventcategoryId?" element={<EventCategoryList />} />
        <Route path="/userprofile/:user_id?" element={<UserProfile />} />
        <Route path="/nearyou" element={<NearYou />} />
        <Route path="/experiencelist/:id?" element={<ExperienceList />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsofuseforusers" element={<TermsOfUseForUsers />} />
        <Route path="/ruleofuse" element={<RuleOfUse />} />
        <Route path="/downloadpage" element={<DownloadPage />} />
      </Routes>

    </div>
  );
}

export default App;
